import { action, observable, makeAutoObservable } from "mobx";
import CookieUtil from "utils/CookieUtil";

export default class LoginModel {
  @observable private username!: string;
  @observable private password?: string;
  @observable private loginAuth!: string;

  private static readonly cookieName = "login";

  public constructor(username:string, loginAuth:string) {
    makeAutoObservable(this);
    this.username = username;
    this.loginAuth = loginAuth;
  }

  get getUsername() {
    return this.username;
  }

  @action
  public setUsername(username: string) {
    this.username = username;
  }

  get getPassword(): string|null|undefined {
    return this.password;
  }

  @action
  public setPassword(password?:string) {
    this.password = password;
  }

  get getLoginAuth() {
    return this.loginAuth;
  }

  @action
  public setLoginAuth(loginAuth: string) {
    this.loginAuth = loginAuth;
  }

  public saveCookies() {
    CookieUtil.set(LoginModel.cookieName, { username: this.username, loginAuth: this.loginAuth }, { expires: CookieUtil.getExpiresDate(365) });
  }

  public static loadCookies() {
    const cookieData = CookieUtil.get(LoginModel.cookieName);
    if(cookieData)
      return new LoginModel(cookieData.username, cookieData.loginAuth);
    else
      return undefined;

  }
}